import axios from '../helpers/axios'
import { logError } from '../services';

export const getOptionNames = async (optionCodes: number[]): Promise<string[]> => {
    try {
        const params = new URLSearchParams();
        optionCodes.forEach(value => params.append('optionCodes', value.toString()));

        const { data } = await axios.get(`/api/bulk-option-exclusions/option-names/`, { params });

        return data;
    } catch (error: any) {
        logError(error, 'getOptionName failed');
        return Promise.reject(error?.response?.data);
    }
};

export const createBulkOptionExclusions = async (post: { optionCodes: string[]; selectedNeighborhoods: any[], selectedPlanStyles: any[] }): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/bulk-option-exclusions`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createBulkOptionExclusions failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const deleteBulkOptionExclusions = async (post: { optionCodes: string[]; selectedNeighborhoods: any[], selectedPlanStyles: any[] }): Promise<any> => {
    try {
        const { data } = await axios.post(`/api/bulk-option-exclusions/delete`, post);
        return data;
    } catch (error) {
        logError(
            {
                error,
                payload: post
            },
            'deleteBulkOptionExclusions failed'
        );
        return Promise.reject(error.response.data);
    }
};

